<footer class="lbn-footer" [ngClass]="'lbn-footer--' + variant" role="contentinfo">
  <p class="lbn-footer__text">
    <span class="lbn-footer__brand">LOADBOARD NETWORK™</span>
    <span class="lbn-footer__sep" aria-hidden="true">|</span>
    <span class="lbn-footer__copy">© 2026 LoadBoard Network LLC</span>
  </p>
</footer>
